import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/store/auth/auth.service';
import { AuthState } from '@app/store/auth/auth.state';
import { Store } from '@ngxs/store';
import { Observable, map, shareReplay, take } from 'rxjs';

@Component({
  selector: 'app-authed',
  templateUrl: './authed.component.html',
  styleUrls: ['./_authed.component.sass'],
})
export class AuthedComponent implements OnInit {
  public menuItens: any;
  public loguedUser: any;
  @ViewChild('drawer') drawer!: MatDrawer;

  isTablet = false;
  isHandset = false;

  constructor(
    private _store: Store,
    private _route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loguedUser = this._store.selectSnapshot(AuthState);

    this.menuItens = this._route.snapshot.data.menuList.map((category) => ({
      ...category,
      itens: category.itens.filter((item) => this.loguedUser?.attributes[item.flag] === 'True'),
    }));

    this.breakpointObserver.observe(Breakpoints.Small).subscribe((result) => {
      this.isTablet = result.matches;
    });

    this.breakpointObserver.observe(Breakpoints.Handset).subscribe((result) => {
      this.isHandset = result.matches;
    });
  }

  toggleDrawer(): void {
    this.drawer.toggle();
  }
}
